export default __webpack_public_path__ + "static/media/tmx_logo_en.5854d8af.svg";